<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span class="title-box-text">
                    Пользователи Quorum
                </span>
            </div>
            <v-spacer></v-spacer>

            <v-text-field @input="getUsers(true)" append-icon="mdi-magnify" class="search-input" hide-details label="Поиск"
                color="var(--app-dark-blue-1)" single-line v-model="search"></v-text-field>
        </div>



        <div>

            <div class="table-container">
                <v-data-table :headers="tableHeaders" :items="users"
                    :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, 200, 300], 'items-per-page-text': '' }"
                    class="elevation-0 main-table" :items-per-page="optionTable.itemsPerPage" :page="optionTable.page"
                    :server-items-length="optionTable.serverItemsLength" @pagination="tableChange" @click:row="goToDetail"
                    ref="sortableTable" fixed-header>
                    <template v-slot:item.lastActivity="{ item }">
                        {{ item.lastActivity | moment(" HH:mm DD.MM.YYYY ") }}
                    </template>
                    <template v-slot:item.dateCreated="{ item }">
                        {{ item.dateCreated | moment(" HH:mm DD.MM.YYYY ") }}
                    </template>



                </v-data-table>

            </div>
        </div>
        <v-divider></v-divider>
    </div>
</template>
<script>


export default {

    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        users: [],
        search: '',
        optionTable: {
            page: 1,
            itemsPerPage: 10,
            serverItemsLength: -1
        },

        tableHeaders: [


            {
                text: 'ID',
                sortable: false,
                align: "left",
                value: 'id',
            },
            {
                text: 'ID устройства',
                sortable: false,
                align: "left",
                value: 'deviceId',
            },
            {
                text: 'Тип устройства',
                sortable: false,
                align: "left",
                value: 'deviceType',

            },
            {
                text: 'Последняя активность',
                sortable: false,
                align: "left",
                value: 'lastActivity',

            },
            {
                text: 'Дата создания',
                sortable: false,
                align: "left",
                value: 'dateCreated',

            },


        ],
    }),
    methods: {
        checkLocal() {
            const localOptionTable = JSON.parse(localStorage.getItem("qUsersOptionTable"))
            const search = localStorage.getItem("qUsersSearch")
            if (localOptionTable) {
                this.optionTable = localOptionTable
            }
            if (search) {
                this.search = search
            }

        },
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },

        goToDetail(item) {
            this.$router.push({ name: 'QuorumUser', params: { id: item.id } })

        },
        getUsers(search) {
            if (search) {
                localStorage.setItem('qUsersSearch', this.search)
                this.optionTable.page = 1
            }
            if (!this.search) {
                localStorage.removeItem("qUsersSearch")
            }
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/quorum/user/list', {
                optionTable: this.optionTable,
                search: this.search
            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {

                    this.optionTable = res.data.optionTable;
                    this.users = res.data.items

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        tableChange(data) {

            this.optionTable.page = data.page
            this.optionTable.itemsPerPage = data.itemsPerPage
            localStorage.setItem('qUsersOptionTable', JSON.stringify(this.optionTable))
            this.getUsers()
        },


    },
    created() {
        this.checkLocal()
        this.getUsers()
    },
}
</script>
<style lang="scss" scoped>
.table-container {
    height: calc(100vh - 195px);

    .main-table {
        height: calc(100vh - 195px) !important;
        min-height: calc(100vh - 195px) !important;
        max-height: calc(100vh - 195px) !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

    }
}
</style>